import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { AddButton } from 'components/ui';
import { SectionHeader } from 'components/ui/typography';
import { periodicCostElementService } from 'features/cost-analysis/costs/api/periodic-cost-element.service';
import { TenantPage } from 'layouts';
import { useTranslation } from 'react-i18next';
import { costElementService } from 'shared/services';
import { CostElementsColumns } from '../cost-elements';

export function CostList() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.cost.list';

  const columns = CostElementsColumns();
  const periodicCostColumns = CostElementsColumns(true);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton to="add" prefix={translationPrefix} requireTenantAdmin />}>
      <SectionHeader title={t(`${translationPrefix}.extraordinary_costs`)} className="py-3" />
      <EnhancedDataGrid columns={columns} service={costElementService} />
      <SectionHeader title={t(`${translationPrefix}.periodic_costs`)} className="py-3" />
      <EnhancedDataGrid columns={periodicCostColumns} service={periodicCostElementService} />
    </TenantPage>
  );
}

export default CostList;
